import NavBar from "../components/nav_bar";
import { birthyearValue } from "../store/notepad";
import t from "../locales";
import Notepad from "../components/notepad";
import SaveInfoTooltip from "../components/save_info_tooltip";
import SystemMessage from "../components/system_message";
import youGameIcon from "../assets/images/you_game.png";
import castleButton from "../assets/images/you_game/button_castle.png";
import socialsButton from "../assets/images/you_game/button_socials.png";
import trophyButton from "../assets/images/you_game/button_trophy.png";
import game1Icon from "../assets/images/you_game/image_game.png";
import game2Icon from "../assets/images/you_game/image_game_2.png";
import profilePicture from "../assets/images/you_game/profile_picture.png";
import favouriteStar from "../assets/images/you_game/favourite_star.png";

function GameIcon({ src }) {
  return (
    <div className="you-game__game">
      <img className="you-game__game-image" src={src} alt="" />
      <div className="you-game__action-buttons">
        <span className="you-game__action-button">{t("yougame_play")}</span>
        <span className="you-game__action-button">{t("yougame_watch")}</span>
      </div>
    </div>
  );
}

export default function YouGame() {
  return (
    <>
      <SystemMessage text={t("yougame_system_message")} />
      <div className="you-game-container">
        <NavBar icon={youGameIcon} />
        <div className="you-game">
          <section className="you-game__header">
            <div className="you-game__profile-pics">
              <img
                className="you-game__profile-pic"
                src={profilePicture}
                alt="profile picture"
              />
              <div className="you-game__profile-buttons">
                <img className="you-game__button" src={trophyButton} alt="" />
                <img className="you-game__button" src={socialsButton} alt="" />
                <img className="you-game__button" src={castleButton} alt="" />
              </div>
            </div>
            <div className="you-game__profile-name">
              <span className="you-game__profile-text">
                <span>{t("yougame_profile_name_prefix")}</span>
                <SaveInfoTooltip name="sportteam">
                  {t("yougame_profile_name_tooltip_part")}
                </SaveInfoTooltip>
                <span>{t("yougame_profile_name_suffix")}</span>
              </span>
              <img src={favouriteStar} alt="" />
            </div>
          </section>
          <section className="you-game__about">
            <p className="you-game__title">{t("yougame_title_about")}</p>
            <dl className="you-game__details">
              <div className="you-game__detail">
                <dt>{t("yougame_geboortejaar_label")}</dt>
                <dd>
                  <SaveInfoTooltip name="birthyear" dir="left">
                    {birthyearValue}
                  </SaveInfoTooltip>
                </dd>
              </div>
              <div className="you-game__detail">
                <dt>{t("yougame_hobbies_label")}</dt>
                <dd>{t("yougame_hobbies")}</dd>
              </div>
              <div className="you-game__detail">
                <dt>{t("yougame_favoriet_spel_label")}</dt>
                <dd>{t("yougame_favoriet_spel")}</dd>
              </div>
              <div className="you-game__detail">
                <dt>{t("yougame_email_label")}</dt>
                <dd>
                  <SaveInfoTooltip name="email">
                    {t("secrets_email_value")}
                  </SaveInfoTooltip>
                </dd>
              </div>
            </dl>
          </section>
          <section className="you-game__recent">
            <p className="you-game__title">
              {t("yougame_title_recent_gespeeld")}
            </p>
            <div className="you-game__games">
              <GameIcon src={game1Icon} />
              <GameIcon src={game2Icon} />
            </div>
          </section>
          <Notepad />
        </div>
      </div>
    </>
  );
}
